import { render } from "./MobileLandingPage.vue?vue&type=template&id=764ed207"
import script from "./MobileLandingPage.vue?vue&type=script&lang=js"
export * from "./MobileLandingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__